export default function RecommendedName({ searchObject, onChange, t }) {
  return (
    <div>
      <legend className="fontsize-legend">{t("Recommended by name")}</legend>
      <input
        className="form-control fontsize-legend"
        name="recommendedName"
        onChange={onChange}
        value={searchObject.recommendedName || ""}
      />
    </div>
  );
}
